
import Vue from "vue";

type WorkspaceActionCardItem = {
  actionLabel?: string;
  countValue?: number | string;
  description?: string;
  icon: string;
  key: string;
  title: string;
  tone?: string;
  tutorialLabel?: string;
};

export default Vue.extend({
  name: "WorkspaceActionCards",

  props: {
    activeKey: {
      type: String,
      default: "",
    },
    compact: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
    accentColor: {
      type: String,
      default: "#7cb342",
    },
    selectable: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleItemClick(item: WorkspaceActionCardItem) {
      if (!this.selectable || item.actionLabel || item.tutorialLabel) {
        return;
      }

      this.$emit("action", item.key);
    },
  },

  computed: {
    accentStyle(): Record<string, string> {
      return {
        "--workspace-cards-accent": this.accentColor,
      };
    },

    normalizedItems(): WorkspaceActionCardItem[] {
      return (this.items as WorkspaceActionCardItem[]).map((item) => ({
        tone: "recipe",
        ...item,
      }));
    },
  },
});
